export function truncate(text: string, maxLength: number | false, clamp?: any) {
    if (!text) return;
    if (maxLength === false) {
        return text;
    } else {
        return text.slice(0, maxLength).trim() + (maxLength < text.length ? clamp || '...' : '');
    }
}
